<template>
    <div class="editLead">
        <Header :code="code">Créer un lead</Header>
        <LeadForm :lead="leadToCreate" @recordLead="createLead" @cancelForm="$router.push({ name: 'Leads', params: { code: code } })"/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import LeadForm from '@/components/LeadForm'
export default {
    name: 'CreateLead',
    props: ['code'],
    components: {
        Header,
        LeadForm
    },
    data() {
        return {
            leadToCreate: {
                civilite: "",
                nom: "",
                prenom : "",
                telephone_mobile : "",
                telephone_fixe : "",
                email: "",
                langue_preferee: "",
                adresse: {
                    rue1 : "",
                    rue2 : "",
                    code_postal: "",
                    ville: ""
                },
                commentaire: ""
            }
        }
        
    },
    methods: {
        createLead(user){
            let leadToCreate = {};
            leadToCreate.code_projet = this.code;
            leadToCreate.id_utilisateur = this.$store.state.user.id
            leadToCreate.data = {
                civilite : user.civilite,
                nom: user.nom,
                prenom: user.prenom,
                email: user.email,
                telephone_mobile: user.telephone_mobile,
                telephone_fixe: user.telephone_fixe,
                telephone_pro: user.telephone_pro,
                rue1: user.adresse.rue1,
                rue2: user.adresse.rue2,
                code_postal: user.adresse.code_postal,
                ville: user.adresse.ville,
                commentaire: user.commentaire,
                source: "WEBAPP",
                autorisation_RGPD_pour_projet: "OUI",
                autorisation_RGPD_pour_autres_projets: "NON",
                source_autorisations: "WEBAPP",
                langue_preferee: user.langue_preferee,
                id_utilisateur: this.$store.state.user.id
            }
            this.$store.dispatch('setLoader', true).then((e)=> {
                this.$store.dispatch('createLead', leadToCreate).then((e)=> {
                    this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=>{
                        this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                            this.$store.dispatch('setLoader', false).then((e) => {
                                this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                            })
                        })
                    })
                })
            })
        }
    },
    computed: {
       
    },
    watch: {
    },
    created() {
        if(this.$store.state.loader){
            this.$store.dispatch('setLoader', false)
        }
    },
}
</script>
<style lang="scss">
    .editLead{
        padding-top: 8vh;
    }
    .account {
        font-size: 0.9em;
        h3 {
            font-size:1.4em;
        }
    }
</style>